<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12" style="margin-top: 8px;">
        <h5 class="m-0">{{Titulo}}</h5>
      </div>
      <div class="col-sm-12" style="margin-top: 5px;">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="/" class="text-azul">Dashboard</a></li>
          <li *ngIf="TemPaginaPai" class="breadcrumb-item"><a href="{{LinkPaginaPai}}" class="text-blue">{{PaginaPai}}</a></li>
          <li *ngIf="Pagina != ''" class="breadcrumb-item active">{{Pagina}}</li>
        </ol>
      </div>
    </div>
  </div>
</div>
